import './voting.scss'
import * as React from 'react'
import { Link } from 'react-navi'
import { Api } from 'src/utils/config'
import rankCircle from "../../../images/rank_circle.png"

import { getOptionInfo, goVoting, goVotingALL } from './api'
import { Cookie } from '../../../utils/cookie'
import { CheckAuth, IsAuth } from '../../../utils/auth'

enum ModalState {
    Open,
    Voting,
    Close
}

interface IProp {
    NECaptchaKey: string,
    voteID: string,
    optionID: string,
    moreUrl: string,
    shopUrl: string,
    success: (...data: any[]) => void
}

interface IState {
    voteSum: number
    remaining: number
    msg: string
    expired: boolean
    init: boolean
    disableVote: number
}

const style = { display: 'none' }

class Voting extends React.Component<IProp, IState>{
    public state = {
        voteSum: 0,
        remaining: 0,
        msg: '',
        expired: false,
        init: false,
        disableVote: 1
    }

    public validate: string = ''
    public voteid: string
    public optionid: string

    public componentWillMount() {
        if (this.props.voteID === this.voteid && this.props.optionID === this.optionid) { return }
        this.voteid = this.props.voteID
        this.optionid = this.props.optionID
        this.caculateVoting(ModalState.Open, ' ')
    }

    public componentWillReceiveProps() {
        if (this.props.voteID === this.voteid && this.props.optionID === this.optionid) { return }
        this.voteid = this.props.voteID
        this.optionid = this.props.optionID
        this.caculateVoting(ModalState.Open, ' ')
    }

    public render() {
        return (
            <div className="other-info" style={!this.state.init ? style : {}}>
                <div className="can-vote">
                    <img className="vote-img" src={rankCircle} alt="" />
                    <span className="vote-num">{this.state.voteSum}</span>
                </div>
                {(!!Cookie.get() || !!Cookie.get(Cookie.WECHATIDKEY)) && <div className="leave-vote">剩余{this.state.remaining > 0 ? this.state.remaining : 0}次可投票机会</div>}
                <div className="voting">{this.state.msg}</div>
                {new IsAuth().check() ?
                    (!this.btnDisable() ?
                        <div>
                            {!!this.validate || <div id={this.props.NECaptchaKey} className="NECaptcha-element" />}
                            <div className={["click-common", "vote-click", (this.btnDisable() || !this.validate) ? "disable" : ''].join(' ')} onClick={(e) => this.voting()}>投票</div>
                            <div className={["click-common", "leave-click", (this.btnDisable() || !this.validate) ? "disable" : ''].join(' ')} onClick={(e) => this.votingAll()}>余票全投给TA</div>
                        </div> :
                        <div>
                            <Link href={this.props.moreUrl}>
                                <div className="click-common leave-click">查看更多精彩</div>
                            </Link>
                            <a style={this.props.shopUrl ? {} : style} href={this.props.shopUrl} className="turn-shop">进入企点店铺了解更多</a>
                        </div>) :
                    <div className={["click-common", "vote-click"].join(' ')} onClick={(e) => this.voting()}>投票</div>}
            </div>
        )
    }
    public btnDisable() {
        return this.state.remaining <= 0 || this.state.expired || this.state.disableVote === 1
    }

    private caculateVoting(state: ModalState, msg?: string) {
        if (!this.voteid || !this.optionid) { return }
        getOptionInfo(this.voteid, this.optionid, Cookie.get(), Cookie.get(Cookie.WECHATIDKEY)).then(res => {
            this.props.success(res, state)
            //    回掉函数
            this.setState({
                voteSum: res.options && res.options[0].vote_num,
                remaining: res.max_num - res.voted_num || 0,
                msg: msg ? msg : "+1",
                expired: (new Date().getTime() / 1000 - res.deadline) > 0 ? true : false,
                init: true,
                disableVote: res.options[0].disable_vote
            }, () => {
                if (!this.btnDisable() && this.isNEcaptchaExpired()) {
                    this.initNECaptcha()
                } else {
                    this.validate = Cookie.get(Cookie.NECAPTCHAVALIDATE)
                    this.setState({})
                }
                setTimeout(() => {
                    this.setState({
                        msg: ''
                    })
                }, 1000)
            })
        })
    }
    private initNECaptcha = () => {
        initNECaptcha({
            captchaId: Api().captchaId,
            element: `#${this.props.NECaptchaKey}`,
            mode: 'float',
            onVerify: (err: any, data: any) => {
                if (!err) {
                    Cookie.set(data.validate, Cookie.NECAPTCHAVALIDATE)
                    Cookie.set(String(new Date().getTime() + 1000 * 60 * 5), Cookie.NECAPTCHAEXPIRATIONTIME)
                    this.validate = data.validate
                    this.setState({})
                }
            }
        })
    }
    private isNEcaptchaExpired = () => {
        if (Number(Cookie.get(Cookie.NECAPTCHAEXPIRATIONTIME)) < new Date().getTime() || !Cookie.get(Cookie.NECAPTCHAVALIDATE)) {
            this.validate = ''
            this.setState({})
            return true
        } else {
            return false
        }
    }
    private voting() {
        CheckAuth.check()
        if (this.btnDisable() || !this.validate) { return }
        goVoting(this.props.voteID, this.props.optionID, Cookie.get(), Cookie.get(Cookie.WECHATIDKEY), this.validate).then(res => {
            let msg = ''
            if (res.code !== 0) {
                if (res.code !== 10019) {
                    msg = res.msg
                }
                Cookie.set('', Cookie.NECAPTCHAVALIDATE)
            }
            // 10003 用户认证失败
            // 20001 未关注公众号
            if (res.code === 10003 || res.code === 20001) {
                Cookie.set('', Cookie.WECHATIDKEY)
                CheckAuth.check()
                return
            }
            this.caculateVoting(ModalState.Voting, msg)
        })
    }
    private votingAll() {
        CheckAuth.check()
        if (this.btnDisable() || !this.validate) { return }
        goVotingALL(this.props.voteID, this.props.optionID, Cookie.get(), Cookie.get(Cookie.WECHATIDKEY), this.validate).then(res => {
            let msg = ' '
            if (res.code !== 0) {
                if (res.code !== 10019) {
                    msg = res.msg
                }
                Cookie.set('', Cookie.NECAPTCHAVALIDATE)
            }
            // 10003 用户认证失败
            // 20001 未关注公众号
            if (res.code === 10003 || res.code === 20001) {
                Cookie.set('', Cookie.WECHATIDKEY)
                CheckAuth.check()
                return
            }
            this.caculateVoting(ModalState.Voting, msg)
        })
    }
}

export {
    Voting,
    ModalState
}


// WEBPACK FOOTER //
// ./src/components/common/voting/voting.tsx